import { styled } from '@mui/material';
import { cn } from '@tempo-io/sui-class-utils';
import { type ComponentProps } from 'react';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export function Title({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cn('text-sm leading-normal uppercase font-semibold', className)} {...props} />;
}

export const HiddenUploadInput = styled('input')({
  opacity: '0',
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  cursor: 'pointer',
});

export const Attachment = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  '& button': { opacity: 0 },
  '&:hover button': { opacity: 1 },
}));

export const ImageContainer = styled('div')(({ theme }) => ({
  height: 60,
  width: 60,
  borderRadius: theme.spacing(0.5),
  '& img': {
    height: 44,
    width: 44,
    objectFit: 'contain',
  },
  backgroundColor: theme.palette.grey['200'],
  padding: theme.spacing(1),
}));

export const AttachmentsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDragging',
})<{
  isDragging: boolean;
}>(({ theme, isDragging }) => ({
  border: `1px dashed ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
  gap: theme.spacing(1),
  backgroundColor: isDragging ? theme.palette.grey['100'] : 'transparent',
  position: 'relative',
}));

export const UploadFileIconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const UploadFileIconBackground = styled('div')({
  backgroundColor: '#0074e0',
  opacity: '12%',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  position: 'absolute',
});

export const UploadFileInstructionsContainer = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  textAlign: 'center',
  justifyContent: 'center',
}));

export function SubText({ className, ...props }: ComponentProps<'p'>) {
  return <p className={cn('text-sm leading-normal text-text-neutral-secondary text-center px-10', className)} {...props} />;
}
